
import { useNavigate } from "react-router-dom";
import { Layout } from "src/components/Layout";
interface ReviewProps { }

export function Review(props: ReviewProps) {
  const navigate = useNavigate();

  const onGoToLogin = () => {
    window.localStorage.setItem("activeTab", "1");
    window.localStorage.removeItem('user')
    window.localStorage.removeItem('token')
    navigate("/login");
  }

  return (
    <Layout>
      <div className="grid md:grid-cols-5">
        <div className="col-span-2 bg-[#233953]">
          <img
            src="/assets/icons/signup/signup_banner.svg"
            className="w-full h-80 md:h-screen object-cover object-top"
            alt="login background"
          />
        </div>
        <div className="col-span-3 px-5 py-5 lg:px-20 lg:py-20 xl:px-44 xl:pt-44 align-middle md:overflow-y-scroll md:h-screen bg-[#122A46]">
          <div className="mb-10 text-center">
            <img
              src="/assets/icons/review/review.svg"
              className="mx-auto mb-6"
              alt="Under Review"
            />
            <h1 className="text-3xl font-bold text-white mb-2">
              Profile under review
            </h1>
            <p className="text-base text-white/70 mb-12 w-[80%] mx-auto">
              We have shared your profile details with team for review. This
              may take some time. Please bear with us.
            </p>
            <button className="text-white border border-white rounded-lg p-3 w-full">
              Contact support
            </button>
            <div className="text-center mt-6">
            <button className="text-white underline cursor-pointer inline-block opacity-80" onClick={onGoToLogin}>
              Back to login
            </button>
          </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
